import { useState, useCallback } from 'react'
import UtentiService from '../services/UtentiService/UtentiService';
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';

const useUtenti = () => {
    const [loadingState, setLoadingState] = useState({
      isLoadingUtenti: false,
      isLoadingUtentiByAgenzia: false,
      isLoadingUtentiCreating: false,
      isLoadingUserByRole: false,
      isLoadingUtentiDeleting: false,
      isLoadingUtentiUpdate: false,
      isLoadingResendEmail: false,
      isLoadingResendEmailNoAuth: false,
      isLoadingInviteFriend: false,
      isLoadingUtenteByParams: false,
      isLoadingUtenteByParamsModal: false,
      isLoadingUtentiEnable: false,
      isLoadingUtentiDisable: false,
      });

    const [modalState, setModalState] = useState({
      showModalCreateUtente: false,
      showModalInfoUtente: false,
      showModalDeleteUtente: false,
      showModalUpdateUtente: false,
      showModalEnableUtente: false,
      showModalDisableUtente: false,
    });

    const getAllUtenti = async () => {
        setLoadingState({ ...loadingState, isLoadingUtenti: true });
        try {
          let response = await UtentiService.getAllUtenti();
          if (response.ok) {
            const utenti = await response.json();
            return utenti;
          } 
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtenti: false });
        }
      };

      const deleteUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiDeleting: true });
        try {
          let response = await UtentiService.deleteUtente(data);
          setModalState({ ...modalState, showModalDeleteUtente: false });
          alertService.success("Invito ritirato con successo", {autoClose: true});
          return response;
        } catch (error) {
          handleError(error, {
            NOT_FOUND: "L'utente con l'email specificata non è stato trovato"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiDeleting: false });
        }
      };

      const enableUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiEnable: true });
        try {
          let response = await UtentiService.enableUtente(data);
          alertService.success("Utente riabilitato con successo", {autoClose: true});
          return response;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiEnable: false });
        }
      };

      const disableUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiDisable: true });
        try {
          let response = await UtentiService.disableUtente(data);
          alertService.success("Utente disabilitato con successo", {autoClose: true});
          return response.success;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiDisable: false });
        }
      };

      const findUsersByRole = async (role) => {
        setLoadingState({ ...loadingState, isLoadingUserByRole: true });
        try {
          let response = await UtentiService.findByRole(role);
          return response;
        } catch (error) {
          handleError(error)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUserByRole: false });
        }
      };

      const createUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiCreating: true });
        try {
          let response = await UtentiService.createUtente(data);
          setModalState(state => ({...state, showModalCreateUtente: false}));
          alertService.success("Utente creato con successo", { autoClose: true });
          return response;
        } catch (err) {
          handleError(err, {
            RESOURCE_ALREADY_EXISTS: "L'utente con l'email specificata è già esistente",
            EMAIL_ERROR: "Inserisci un indirizzo email valido"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiCreating: false });
        }
      };

      const resendEmail = async (data) => {
        setLoadingState({ ...loadingState, isLoadingResendEmail: true });
        try {
          let response = await UtentiService.resendEmail(data);
          alertService.success(`Un nuovo invito è stato inviato a ${data?.username}`, {autoClose: true});
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non esiste"
          }
          )
        } finally {
            setLoadingState({ ...loadingState, isLoadingResendEmail: false });
        }
      };

      const resendEmailNoAuth = async (data) => {
        setLoadingState({ ...loadingState, isLoadingResendEmailNoAuth: true });
        try {
          let response = await UtentiService.resendEmailNoAuth(data);
          alertService.success(`Email inviata con successo`, {autoClose: true});
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non esiste"
          }
          )
        } finally {
            setLoadingState({ ...loadingState, isLoadingResendEmailNoAuth: false });
        }
      };

      const findByIdAgenzia = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiByAgenzia: true });
        try {
          let response = await UtentiService.findByIdAgenzia(data);
          if(response?.length > 0) {
            const users = response.filter(user => user.tipo_utente === "corsista")
            return users;
          }
          return [];
        } catch (err) {
          handleError(err)
        } finally {
            setLoadingState({ ...loadingState, isLoadingUtentiByAgenzia: false });
        }
      };

      const inviteFriend = async (data) => {
        setLoadingState({ ...loadingState, isLoadingInviteFriend: true });
        try {
          let response = await UtentiService.inviteFriend(data);
          if(response){
            alertService.success("Invito inviato con successo", {autoClose: true});
          }
          return response;
        } catch (err) {
          handleError(err, {
            NOT_FOUND: "L'utente con l'email specificata non è stato trovato"
          })
        } finally {
            setLoadingState({ ...loadingState, isLoadingInviteFriend: false });
        }
      }


      const getUtenteByParams = async (params, isModal = false) => {
        if(isModal) {
          setLoadingState({ ...loadingState, isLoadingUtenteByParamsModal: true });
        } else {
          setLoadingState({ ...loadingState, isLoadingUtenteByParams: true });
        }
        try {
          let obj;
          let response = await UtentiService.getUtenteByParams(params);
          const res = await response.json();
          const totalRecord = response.headers.get('X-Total-Record');
            obj = {
              data: res,
              count: totalRecord
            }
          return obj
        } catch (err) {
          handleError(err)
        } finally {
          if(isModal) {
            setLoadingState({ ...loadingState, isLoadingUtenteByParamsModal: false });
          } else {
            setLoadingState({ ...loadingState, isLoadingUtenteByParams: false });
          }
        }
      }

      const generaStringaNumericaRandom = () => {
        // Genera un numero fino a 10 miliardi e lo formatta per avere sempre 10 cifre
        const numeroRandom = Math.floor(Math.random() * 10000000000);
        return numeroRandom.toString().padStart(10, '0');
      };

      const updateUtente = async (data) => {
        setLoadingState({ ...loadingState, isLoadingUtentiUpdate: true });
      
        try {
          const formData = new FormData();

          // Aggiunge tutti i dati testuali al FormData
          for (const key in data) {
            if (
              data[key] !== null &&
              data[key] !== undefined &&
              !key.startsWith('file_') // Escludiamo tutti i campi file
            ) {
              formData.append(key, data[key]);
            }
          }

          // Funzione interna per rinominare e aggiungere i file
          const processAndAppendFile = (file, fieldName) => {
            if (!file) return;

            // 1. Estrae nome ed estensione originali
            const nomeOriginale = file.name;
            const ultimoPunto = nomeOriginale.lastIndexOf('.');
            const nomeSenzaEstensione = nomeOriginale.slice(0, ultimoPunto);
            const estensione = nomeOriginale.slice(ultimoPunto + 1);

            // 2. Crea il nuovo nome con il numero random
            const nuovoNomeFile = `${nomeSenzaEstensione}_${generaStringaNumericaRandom()}.${estensione}`;

            // 3. Crea un nuovo oggetto File con il nuovo nome
            const fileRinominato = new File([file], nuovoNomeFile, { type: file.type });

            // 4. Aggiunge il file rinominato al FormData
            formData.append(fieldName, fileRinominato);
          };

          // Applica la logica di rinomina a tutti e 4 i file
          processAndAppendFile(data.file_documento, 'documentoRiconoscimento');
          processAndAppendFile(data.file_codicefiscale, 'codiceFiscale');
          processAndAppendFile(data.file_documento_retro, 'documentoRiconoscimentoRetro');
          processAndAppendFile(data.file_codicefiscale_retro, 'codiceFiscaleRetro');

          // Chiamata al server con i dati e i file rinominati
          const response = await fetch(`${process.env.REACT_APP_REST_ENDPOINT}/utenti/update`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            body: formData,
          });

          const result = await response.json();
          if (!response.ok) throw result;

          alertService.success("Profilo aggiornato con successo", { autoClose: true });
          return result;
        } catch (error) {
          handleError(error);
        } finally {
          setLoadingState({ ...loadingState, isLoadingUtentiUpdate: false });
        }
      };
      
      const getTabCounts = async (params) => {
        try {
          // Non impostiamo lo stato di caricamento per questa chiamata veloce
          const response = await UtentiService.getTabCounts(params);
          const res = await response.json();
          return res;
        } catch (err) {
          handleError(err);
          // Restituisce un oggetto di default in caso di errore per non rompere la UI
          return { inCorso: 0, completati: 0, archiviati: 0 }; 
        }
      };

      // const updateUtente = async (data) => {
      //   setLoadingState({ ...loadingState, isLoadingUtentiUpdate: true });
      //   try {
      //     let response = await UtentiService.updateUtente(data);
      //     alertService.success("profilo aggiornato con successo", {autoClose: true});
      //     return response;
      //   } catch (error) {
      //     handleError(error)
      //   } finally {
      //       setLoadingState({ ...loadingState, isLoadingUtentiUpdate: false });
      //   }
      // };

      const downloadActivityReport = useCallback(async (id_utente, id_corso) => {
          setLoadingState(prev => ({ ...prev, isDownloadingReport: true }));
          
          const reportData = {
              id_utente: id_utente,
              id_corso: id_corso,
              filename: `report_utente_${id_utente}.pdf` // Passiamo il nome del file
          };

          try {
              // La logica di download è ora gestita da ApiService
              await UtentiService.downloadActivityReport(reportData);
              alertService.success("Report scaricato con successo!");
          } catch (error) {
              handleError(error, { DEFAULT: "Impossibile scaricare il report." });
          } finally {
              setLoadingState(prev => ({ ...prev, isDownloadingReport: false }));
          }
      }, []);

  return {
    loadingStateUtenti: loadingState,
    modalStateUtenti: modalState,
    setModalStateUtenti: setModalState,
    getAllUtenti,
    createUtente,
    findUsersByRole,
    findByIdAgenzia,
    deleteUtente,
    resendEmailNoAuth,
    resendEmail,
    inviteFriend,
    getUtenteByParams,
    getTabCounts,
    disableUtente,
    enableUtente,
    updateUtente,
    downloadActivityReport
  };      
}

export default useUtenti;